export default __webpack_public_path__ + "static/media/bg_image.f47ec7c9.jpg";